

const DATA_USER= {
    userName: 'alin',
    email: `alin2022@hotmail.com`,
    password: `alin2022`
}

export { DATA_USER }